import { apiGet, apiPost, apiRequest } from "./client";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const resourcesApi = {
  /** List root (folders + files) */
  listRoot: () => apiGet("/api/resources"),
  /** List a folder by id (returns {folder, breadcrumb, folders, files}) */
  listFolder: (folderId) => apiGet(`/api/resources/folders/${folderId}`),
  /** Build a download URL (uses cookie auth) */
  downloadUrl: (fileId) => `${API_BASE}/api/resources/files/${fileId}/download`,
};

export const resourcesAdminApi = {
  createFolder: (name, parentId = null) =>
    apiPost("/api/admin/resources/folders", { name, parent_id: parentId }),
  updateFolder: (id, patch) =>
    apiRequest(`/api/admin/resources/folders/${id}`, {
      method: "PATCH",
      body: patch,
    }),
  deleteFolder: (id) =>
    apiRequest(`/api/admin/resources/folders/${id}`, { method: "DELETE" }),

  uploadFile: async (file, folderId = null, displayName = null) => {
    const fd = new FormData();
    fd.append("file", file);
    if (folderId) fd.append("folder_id", folderId);
    if (displayName) fd.append("name", displayName);
    const res = await fetch(`${API_BASE}/api/admin/resources/files`, {
      method: "POST",
      credentials: "include",
      body: fd,
    });
    if (!res.ok) {
      const body = await res.text();
      throw new Error(`Upload failed (${res.status}): ${body}`);
    }
    return res.json();
  },
  updateFile: (id, patch) =>
    apiRequest(`/api/admin/resources/files/${id}`, {
      method: "PATCH",
      body: patch,
    }),
  deleteFile: (id) =>
    apiRequest(`/api/admin/resources/files/${id}`, { method: "DELETE" }),
};

/** Human-readable file size: 12.4 MB / 850 KB / 320 B */
export const humanFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

/** Map MIME type to a Phosphor icon name (caller renders the icon). */
export const fileKind = (mimeType, name = "") => {
  const m = (mimeType || "").toLowerCase();
  const ext = (name.split(".").pop() || "").toLowerCase();
  if (m.startsWith("image/")) return "image";
  if (m.startsWith("video/")) return "video";
  if (m.startsWith("audio/")) return "audio";
  if (m === "application/pdf" || ext === "pdf") return "pdf";
  if (
    m.includes("word") ||
    ["doc", "docx", "rtf", "odt"].includes(ext)
  )
    return "doc";
  if (
    m.includes("sheet") ||
    m.includes("excel") ||
    ["xls", "xlsx", "csv", "ods"].includes(ext)
  )
    return "sheet";
  if (
    m.includes("presentation") ||
    m.includes("powerpoint") ||
    ["ppt", "pptx", "odp"].includes(ext)
  )
    return "slides";
  if (m.includes("zip") || ["zip", "rar", "7z", "tar", "gz"].includes(ext))
    return "archive";
  return "file";
};
